import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { RedirectComponent } from './redirect.component';
import { SharedModule } from 'lib-trend-core';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    SharedModule
  ],
  declarations: [
    RedirectComponent,
  ],
  exports: [
    RedirectComponent,
  ],
  providers: [
  ]
})

export class RedirectModule { }
